import api from '../../../plugins/api';
import { checkError, cloneDeep, parseAddressToApp, prepareApiParams } from 'erp-skeleton-library/utils';
import {userType} from "../../../plugins/enums";

const template = {
  id: 0,
  name: null,
  tradeName: null,
  taxId: null,
  type: null,
  email: null,
  phones: [ {} ],
  addresses: [
    {
      address: {
        zipCode: undefined,
        city: undefined,
        state: undefined,
        address: undefined,
        number: undefined,
      },
    },
  ],
}

const state = {
  tableLoading: false,
  allCollaborators: [],
  registerCollaborators: cloneDeep(template),
  collaboratorsRoles: [
    {
      id: 2,
      label: 'Administrador'
    },
    {
      id: 3,
      label: 'Colaborador'
    }
  ],
  headers: [
    {
      text: 'Nome',
      align: 'left',
      value: 'name',
    },
    {
      text: 'CPF',
      align: 'left',
      value: 'taxId',
    },
    {
      text: 'Email',
      align: 'left',
      value: 'email',
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allCollaborators = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    if (!!payload) {
      payload.addresses = parseAddressToApp(payload);
      payload.phones = (payload.phones) ? payload.phones : [ {} ];
      state.registerCollaborators = payload;

    } else {
      state.registerInstructor = cloneDeep(template);
    }
  },
  CREATE_PHONE(state) {
    state.registerInstructor.phones.push({});
  },
  DELETE_PHONE(state, index) {
    state.registerInstructor.phones.splice(index, 1);
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('users', payload)
           .then(response => {
              resolve(response.data);;
           }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    state.tableLoading = true;
    let query = prepareApiParams(payload, 'id, name, taxId, email');
    query.type = '{' + userType.TYPE_SUPPORT + ', ' +  userType.TYPE_ADMIN + '}';

    return new Promise((resolve, reject) => {
      api
        .get('users?' + new URLSearchParams(query).toString())
        .then(response => {
          commit('LIST', response.data.entities);
          state.tableLoading = false;
           resolve(response.data);;
        })
        .catch(error => {
          state.tableLoading = false;
          checkError(error.response.status);
          reject(error.response);
        });
    });
  },
  read({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.get('users/' + id)
           .then(response => {
             commit('SET', response.data);
             resolve(response.data);
           }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('users/' + payload.id, payload).then(response => {
         resolve(response.data);;
      }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete('users/' + id)
           .then((response) => {
              resolve(response.data);;
           })
           .catch((error) => {
             checkError(error.response.status);
             reject(error.response);
           });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
